import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';
import { SigninWithOtpComponent } from 'src/app/modules/auth/_components/signin-with-otp/signin-with-otp.component';
import { PopupService } from 'src/app/modules/shared/_components/pricing-popup/popup.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-subscribe-now-strip',
  templateUrl: './subscribe-now-strip.component.html',
  styleUrls: ['./subscribe-now-strip.component.scss']
})
export class SubscribeNowStripComponent implements OnInit, OnDestroy {
  @Input() daysLeft: number | null = null;
  @ViewChild(SigninWithOtpComponent) modal!: SigninWithOtpComponent;
  isLoggedIn: any;
  private userSubscription!: Subscription;
  isModalvis: boolean = false;

  constructor(private authService: AuthService,private popupService: PopupService) {
  }

  ngOnInit(): void {
    this.userSubscription = this.authService.user$.subscribe(user => {
      this.isLoggedIn = !!user;
    });
  }

  openModalWithComponent() {
    this.isModalvis = true;
    setTimeout(() => {
      if (this.modal) {
        this.modal.isVisible = true;
        this.modal.isDownloadDoc = true; 
      }
    }, 0);
  }

  onUpgrade() {
    this.popupService.openPricingPopup();
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

}
